import { useState } from 'react';
import styles from './PhotoModal.module.css';
import Modal from '../../../../../Modal';
import { IProfilePhoto } from '../../../../../../../models/Profile/IProfilePhoto';
import { handleErrorResponse } from '../../../../../../../services';
import SHRMMessage from '../../../../../SHRMMessage';

type PhotoModalProps = {
  profilePhoto: IProfilePhoto;
  phoneModalClose: () => void;
  onDeletePhoto: () => Promise<unknown>;
  onUploadPhoto: (profilePhoto: IProfilePhoto) => Promise<unknown>;
};

const PhotoModal = (props: PhotoModalProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const [fileName, setFileName] = useState();
  const [popupMesage, setPopupMessage] = useState('');
  const [popupMessageColor, setPopupMessageColor] = useState('');
  const [showPopupMessage, setShowPopupMessage] = useState(false);

  const [profilePhoto, setProfilePhoto] = useState<IProfilePhoto>(props.profilePhoto);

  const handleModalOpen = () => {
    setIsOpen(true);
  };

  const handleModalClose = () => {
    setIsOpen(false);
  };

  const handleDeletePhoto = () => {
    props
      .onDeletePhoto()
      .then((response: any) => {
        props.phoneModalClose();
      })
      .catch((_error: any) => {
        const message = handleErrorResponse(_error);
        setPopupMessage(message);
        setPopupMessageColor('var(--shrmRed)');
        setShowPopupMessage(true);
      })
      .finally(() => {
        setTimeout(() => {
          setShowPopupMessage(false);
        }, 3000);
      });
  };

  const handleUploadPhoto = () => {
    var profilePhotoToBeUploaded = profilePhoto;
    profilePhotoToBeUploaded.imageName = fileName;
    setFileName(null);
    props
      .onUploadPhoto(profilePhotoToBeUploaded)
      .then((response: any) => {
        props.phoneModalClose();
      })
      .catch((_error: any) => {
        const message = handleErrorResponse(_error);
        setPopupMessage(message);
        setPopupMessageColor('var(--shrmRed)');
        setShowPopupMessage(true);
      })
      .finally(() => {
        setTimeout(() => {
          setShowPopupMessage(false);
        }, 3000);
      });
  };

  function _handleReaderLoaded(readerEvt) {
    var binaryString = readerEvt.target.result;
    setProfilePhoto({
      ...profilePhoto,
      base64Image: window.btoa(binaryString),
    });
  }

  const onFileChange = (event: any) => {
    var files = event.target.files;
    var file = files[0];

    if (files && file) {
      var reader = new FileReader();
      reader.onload = _handleReaderLoaded.bind(this);
      reader.readAsBinaryString(file);
      setFileName(file.name);
    }
  };

  return (
    <>
      <Modal open={isOpen}>
        <div className={styles.modalHeader}>Delete Picture</div>
        <div className={styles.modalBody}>
          Are you sure you want to remove your profile picture?
        </div>
        <div className={styles.modalButtons}>
          <button className={styles.blueButton} onClick={handleDeletePhoto}>
            Yes
          </button>
          <button className={styles.whiteButton} onClick={handleModalClose}>
            No
          </button>
        </div>
      </Modal>

      <div id='modal'>
        <div className={styles.container}>
          <div
            className={styles.content}
            onClick={e => {
              e.stopPropagation();
            }}
          >
            <div className={styles.header}>
              <label className={styles.title}>Profile Picture</label>
              <button className={styles.closeModalButton} onClick={props.phoneModalClose}>
                ×
              </button>
            </div>
            <div className={styles.form}>
              <br />
              <SHRMMessage
                color={popupMessageColor}
                text={popupMesage}
                showMessage={showPopupMessage}
              />
              <div>
                <input type='file' onChange={onFileChange} />
              </div>
            </div>
            <div className={styles.footer}>
              <button
                type='button'
                className={styles.saveButton}
                disabled={!fileName}
                onClick={handleUploadPhoto}
              >
                Upload
              </button>
              <div className={styles.cancelButton} onClick={props.phoneModalClose}>
                Cancel
              </div>
              {props.profilePhoto?.profilePhotoId && (
                <div className={styles.deleteButton} onClick={handleModalOpen}>
                  <a>Delete Picture</a>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PhotoModal;
